module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/watch-h5.c70973e1.jpg";